import React from 'react'

export const RelatedProduct = () => {
  return (
    <div>RelatedProduct</div>
  )
}